import { ApiAuthError, ApiHttpError, ApiNetworkError } from '@/shared/api/client';
import {
  AUTH_ROUTE_ERROR_KIND,
  HTTP_ROUTE_ERROR_KIND,
  ROUTE_ERROR_MESSAGES,
  type RouteErrorKind,
} from '@/shared/config/routeErrorMessages';
import type { MessageDescriptor } from '@lingui/core';

function routeErrorKind(error: unknown): RouteErrorKind {
  if (error instanceof ApiNetworkError) return 'network';
  if (error instanceof ApiAuthError) return AUTH_ROUTE_ERROR_KIND[error.reason] ?? 'unknown';
  if (error instanceof ApiHttpError) {
    return HTTP_ROUTE_ERROR_KIND[error.status] ?? (error.status >= 500 ? 'server' : 'unknown');
  }
  return 'unknown';
}

export function routeErrorDescriptor(error: unknown): MessageDescriptor {
  return ROUTE_ERROR_MESSAGES[routeErrorKind(error)] ?? ROUTE_ERROR_MESSAGES.unknown;
}
